import LinearProgress from '@mui/material/LinearProgress';
import Typography from '@mui/material/Typography';
import PropTypes from 'prop-types';
import clsx from 'clsx';

function FuseLoading(props) {
	return (
		<div className={clsx('flex flex-1 flex-col items-center justify-center p-24')}>
			<Typography className="text-13 sm:text-20 mb-16" color="textSecondary">
				{props.title || 'Indlæser...'}
			</Typography>
			<LinearProgress className="w-192 sm:w-320 max-w-full rounded-2" color="secondary" />
		</div>
	);
}

FuseLoading.propTypes = {
	delay: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]),
};

FuseLoading.defaultProps = {
	delay: false,
};

export default FuseLoading;
